export enum ControllerRestartMethod {
  SMS = 'SMS',
  SSH = 'SSH',
}

export enum ExecutionStatus {
  QUEUED = 'QUEUED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  TIMED_OUT = 'TIMED_OUT',
  CANCELED = 'CANCELED',
  REJECTED = 'REJECTED',
  REMOVED = 'REMOVED',
}

export enum SshStatus {
  QUEUED = 'QUEUED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
}

export enum SmsStatus {
  DELIVERED_TO_SERVICE_PROVIDER = 'DELIVERED_TO_SERVICE_PROVIDER',
  DELIVERED_TO_MOBILE_OPERATOR = 'DELIVERED_TO_MOBILE_OPERATOR',
  DELIVERED_TO_RECIPIENT = 'DELIVERED_TO_RECIPIENT',
  DELIVERY_FAILED = 'DELIVERY_FAILED',
  MESSAGE_EXPIRED = 'MESSAGE_EXPIRED',
}

export interface SshStatusHistoryEntry {
  status: SshStatus
  statusUpdatedAt: string
}

export interface SmsStatusHistoryEntry {
  status: SmsStatus
  statusUpdatedAt: string
  errorMessage?: string
}

export interface ExecutionStatusDetailsResponse {
  vpnTaskId?: string
  smsCommandId?: string
  reason?: string
  sshStatusHistory?: SshStatusHistoryEntry[]
  smsStatusHistory?: SmsStatusHistoryEntry[]
}

export interface ExecutionResponse {
  id: string
  parentJobId: string
  controllerId: string
  executionMethod: ControllerRestartMethod
  status: ExecutionStatus
  statusDetails?: ExecutionStatusDetailsResponse
  queuedAt: string
  startedAt?: string
  completedAt?: string
}

export interface ControllerRestartStatusResponse {
  hasActiveRestart: boolean
  lastRestart?: ExecutionResponse
}
